import { Typography } from "@circle-react-shared/uikit/Typography";

import { t } from "@/i18n-js/instance";

import { FeatureRow } from "../FeatureRow";
import { SectionWrapper } from "./SectionWrapper";

export const Services = () => {
  const standardTranslation = t("pricing_plans.feature.standard");
  const priorityTranslation = t("pricing_plans.feature.priority");

  return (
    <>
      <SectionWrapper sectionName={t("pricing_plans.section.services")}>
        <FeatureRow
          title={t("pricing_plans.feature.concierge")}
          basic={false}
          professional={false}
          enterprise={t("pricing_plans.feature.concierge_enterprise")}
          business={false}
          plus={t("pricing_plans.feature.concierge_plus")}
        />
        <FeatureRow
          title={t("pricing_plans.feature.support_dedicated")}
          basic={false}
          professional={false}
          enterprise={false}
          business={false}
          plus
        />
        <FeatureRow
          title={t("pricing_plans.feature.business_review")}
          basic={false}
          professional={false}
          enterprise={false}
          business={false}
          plus
        />
        <FeatureRow
          title={t("pricing_plans.feature.monthly_review")}
          basic={false}
          professional={false}
          enterprise={false}
          business={false}
          plus={t("pricing_plans.feature.flexible")}
        />
        <FeatureRow
          title={t("pricing_plans.feature.email_hub_migration")}
          basic={false}
          professional={standardTranslation}
          enterprise={standardTranslation}
          business={standardTranslation}
          plus={priorityTranslation}
        />
        <FeatureRow
          title={t("pricing_plans.feature.courses_migration")}
          basic={false}
          professional={false}
          business={standardTranslation}
          enterprise={priorityTranslation}
          plus={priorityTranslation}
        />
        <FeatureRow
          title={t("pricing_plans.feature.payments_migration")}
          basic={false}
          professional={false}
          business={standardTranslation}
          enterprise={priorityTranslation}
          plus={priorityTranslation}
        />
        <FeatureRow
          title={t("pricing_plans.feature.content_migration")}
          basic={false}
          professional={false}
          business={standardTranslation}
          enterprise={priorityTranslation}
          plus={priorityTranslation}
        />
      </SectionWrapper>
      <div className="-mt-6">
        <Typography.BodySm weight="normal" color="tertiary">
          {t("pricing_plans.comparison_table.footer")}
        </Typography.BodySm>
      </div>
    </>
  );
};
